import React, { useState, useEffect } from 'react';
import { Routes, Route } from "react-router-dom";
import QuotaAlert from '../components/common/QuotaAlert';
import { setQuotaAlertCallback } from '../helpers/ApiHelper';

//layouts
import NonAuthLayout from "../layouts/NonAuthLayout";
import VerticalLayout from "../layouts/index";

//routes
import { authProtectedRoutes, publicRoutes } from "./AllRoutes";
import { AuthProtected } from './AuthProtected';

const Index = () => {
    const [showQuotaAlert, setShowQuotaAlert] = useState(false);

    useEffect(() => {
        // Register the callback when component mounts
        setQuotaAlertCallback((show) => setShowQuotaAlert(show));

        // Cleanup when component unmounts
        return () => setQuotaAlertCallback(null);
    }, []);

    return (
        <React.Fragment>
            <QuotaAlert 
                isOpen={showQuotaAlert} 
                toggle={() => setShowQuotaAlert(false)} 
            />
            <Routes>
                {publicRoutes.map((route, idx) => (
                    <Route
                        path={route.path}
                        element={
                            <NonAuthLayout>
                                {route.component}
                            </NonAuthLayout>
                        }
                        key={idx}
                    />
                ))}

                {authProtectedRoutes.map((route, idx) => (
                    <Route
                        path={route.path}
                        element={
                            <AuthProtected
                                requiredSubscription={route.requiredSubscription}
                                requiredFeature={route.requiredFeature}
                            >
                                <VerticalLayout>{route.component}</VerticalLayout>
                            </AuthProtected>
                        }
                        key={idx}
                    />
                ))}
            </Routes>
        </React.Fragment>
    );
};

export default Index;
